// src/features/inventory/hooks/useInventoryItems.js
import { useState, useCallback } from 'react';
import { itemsAPI } from '../services/items';
import { useApi } from '../../../hooks/api/useApi';

export function useInventoryItems() {
  const [items, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchItems = useCallback(async (productGroupId = null) => {
    const result = await execute(() => itemsAPI.getItems(productGroupId));
    if (result.success) {
      setItems(result.data.data || []);
    }
    return result;
  }, [execute]);

  const fetchItemById = useCallback(async (itemId) => {
    const result = await execute(() => itemsAPI.getItemById(itemId));
    if (result.success) {
      setCurrentItem(result.data.data);
    }
    return result;
  }, [execute]);

  const createItem = useCallback(async ({
    product_group_id,
    sku,
    name,
    description = null,
    uom,
  }) => {
    const result = await execute(() =>
      itemsAPI.createItem({ product_group_id, sku, name, description, uom })
    );
    if (result.success) {
      setItems(prev => [...prev, result.data.data]);
    }
    return result;
  }, [execute]);

  const updateItem = useCallback(async (itemId, {
    name,
    description,
    uom,
    active,
  }) => {
    const result = await execute(() =>
      itemsAPI.updateItem(itemId, { name, description, uom, active })
    );
    if (result.success) {
      const updated = result.data.data;
      setCurrentItem(updated);
      setItems(prev => prev.map(item => item.item_id === itemId ? updated : item));
    }
    return result;
  }, [execute]);

  const deleteItem = useCallback(async (itemId) => {
    const result = await execute(() => itemsAPI.deleteItem(itemId));
    if (result.success) {
      setItems(prev => prev.filter(item => item.item_id !== itemId));
      setCurrentItem(null);
    }
    return result;
  }, [execute]);

  return {
    items,
    currentItem,
    loading,
    error,
    clearError,
    fetchItems,
    fetchItemById,
    createItem,
    updateItem,
    deleteItem,
  };
}
